import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import withRouter from "../../../data/shared/withRouter";
import {Navigate} from "react-router-dom";
import {generate} from "../../../routing/routes";
import {getHikeBySlug} from "../../../data/booking/api/api";
import {PageLoader} from "../../shared/components/PageLoader";
import i18n from "../../../i18n";
import {
    selectHike,
} from "../../../data/booking/actions/map";
import {isEmpty} from "lodash";

const FromHikeToBookRedirect = ({router}) => {

    const [loading, setLoading] = useState(true);
    const hike = useSelector(state => state.booking.map.hike)
    const dispatch = useDispatch()

    useEffect(() => {
        if(hike) {
            setLoading(false)
        }
    }, [hike]);

    useEffect(() => {
        const {slug} = router.params
        getHikeBySlug(slug, i18n.language)
            .then(response =>response.json())
            .then(json =>{
                if(!isEmpty(json)){
                    dispatch(selectHike(json))
                } else {
                    setLoading(false);
                }
            })
    }, []);

    if(loading) {
        return <PageLoader/>
    } else {
        return <Navigate to={generate('book')} replace={true}/>
    }
}

export default withRouter(FromHikeToBookRedirect)